import * as React from "react";
import { CategoryType } from "../../../dtos/Tmd.dtos";

import "./MultiSelect.scss";

export interface SelectableOption {
    id: number;
    selected: boolean;
    name: string;
    categoryType?: CategoryType;
}

interface IMultiSelectProps {
    selectableOptions: Array<SelectableOption>;
    optionSelected: (option: SelectableOption) => void;
    showCategoryTypes?: boolean;
    categoryTypes?: string[];
}

class MultiSelect extends React.PureComponent<IMultiSelectProps, any> {
    render() {
        let categoryTypeGroups = undefined;
        if (this.props.showCategoryTypes) {
            var selectableOptions = this.props.selectableOptions.sort((a, b) =>
                a.categoryType < b.categoryType ? -1 : 1
            );

            // Group by categoryType property
            categoryTypeGroups = selectableOptions.reduce(
                (groups, item) => ({
                    ...groups,
                    [item.categoryType]: [
                        ...(groups[item.categoryType] || []),
                        item,
                    ],
                }),
                {}
            );
            categoryTypeGroups = Object.keys(categoryTypeGroups).map((key) => {
                return [key, categoryTypeGroups[key]];
            });
        }

        return (
            <div className="multiselect custom-scrollbar">
                {this.props.showCategoryTypes &&
                this.props.selectableOptions ? (
                    <>
                        {categoryTypeGroups.map((v, _index, _array) => {
                            return (
                                <span key={"categoryType" + v[0]}>
                                    <strong style={{ paddingLeft: "5px" }}>
                                        {this.props.categoryTypes[v[0]]}
                                    </strong>{" "}
                                    {v[1].map((value, _index, _array) => {
                                        return (
                                            <div
                                                key={
                                                    "categoryValue" +
                                                    v[0] +
                                                    "_" +
                                                    value.categoryType +
                                                    "_" +
                                                    value.id
                                                }
                                                className="row"
                                            >
                                                <div className="col-md-12">
                                                    <span
                                                        onClick={() =>
                                                            this.props.optionSelected(
                                                                value
                                                            )
                                                        }
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                                marginLeft:
                                                                    "10px",
                                                            }}
                                                            checked={
                                                                value.selected
                                                            }
                                                            readOnly={true}
                                                        />
                                                        <label
                                                            style={{
                                                                marginLeft:
                                                                    "6px",
                                                                marginBottom:
                                                                    "0px",
                                                            }}
                                                        >
                                                            {value.name}
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </span>
                            );
                        })}
                    </>
                ) : (
                    <>
                        {this.props.selectableOptions &&
                            this.props.selectableOptions.map(
                                (value, _index, _array) => {
                                    return (
                                        <div key={value.id} className="row">
                                            <div className="col-md-12">
                                                <span
                                                    onClick={() =>
                                                        this.props.optionSelected(
                                                            value
                                                        )
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        style={{
                                                            marginLeft: "10px",
                                                        }}
                                                        checked={value.selected}
                                                        readOnly={true}
                                                    />
                                                    <label
                                                        style={{
                                                            marginLeft: "6px",
                                                            marginBottom: "0px",
                                                        }}
                                                    >
                                                        {value.name}
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                    </>
                )}
            </div>
        );
    }
}

export default MultiSelect;
